import React, {useContext} from "react";
import {css} from "emotion";
import GenericCard from "../GenericCard";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import Toggle from "../Toggle";
import {GlobalContext} from "../../context/GlobalState";
import spotlights from "../../services/api/spotlights";

const LiveSwitch = () => {
  const {currentSpotlight, setActiveSpotlight, deactivateSpotlight} = useContext(GlobalContext);

  const setLiveStatus = async () => {
    if (!currentSpotlight.isActive) {
      try {
        setActiveSpotlight();
        await spotlights.setActiveSpotlight(currentSpotlight);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        deactivateSpotlight();
        await spotlights.deactivateSpotlight({workspace: currentSpotlight.workspace});
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <GenericCard style={container}>
      <p>Default Spotlight</p>
      <Toggle value={currentSpotlight.isActive} toggle={setLiveStatus}/>
    </GenericCard>
  );
};

export default LiveSwitch;

const container = css`
  padding: ${boxStyles.standardPadding};
  width: 30%;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-top: 30px;
  p {
    color: ${colors.titleColor};
    font-size: ${textSizes.normal};
  }
  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    width: 50%;
  }
`;
